import { useState } from 'react';
import { navigate, paths } from '../lib/router';
import { useDeckStore } from '../store/deckStore';

/** Opens the editor for a new deck, optionally with the AI draft dialog. */
export function useCreateDeck() {
  const newDeck = useDeckStore((s) => s.newDeck);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const create = async (withAi: boolean) => {
    setCreating(true);
    try {
      const id = await newDeck();
      if (id) navigate(paths.edit(id, withAi ? 'ai=1' : undefined));
      else setError("Couldn't reach the server to create the deck. Try again.");
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not create a deck');
    } finally {
      setCreating(false);
    }
  };
  return { create, creating, error, setError };
}
